<template>
  <div class="flow-create-chart-wrap">
    <BpmnEditorComponents v-model="form.id"></BpmnEditorComponents>
  </div>
</template>

<script>

import Http from "../common/Http";
import BpmnEditorComponents from '../bpmn/BpmnEditorComponents.vue'

export default {
  name:"flow-create-chart",
  props: ["value"],
  components: {BpmnEditorComponents},
  data () {
    return {
      form: {id: 0}
    }
  },

  activated() {
    console.log('flow chart activated')

    if(this.value.master.cache && this.value.master.cache.sheet) {
      this.form = this.value.master.cache.sheet
      return
    }

    if(this.value.sheet) {
      this.form = this.value.sheet
      return
    }

    this.form = {id: 0}
    this.value.sheet = this.form

  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>

@import '../common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowCreateChart.vue